module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NU-954e7f18759f2a9046de8d6acbac4363.png";